<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card v-on:keyup.enter="buildNewSearch">
		<v-card-title>
			<h2>Wnioski placówki</h2>
			<v-spacer></v-spacer>
		</v-card-title>

		<v-layout align-center justify-center row>
			<v-flex sm3>
				<v-autocomplete
					class="ma-2"
					aria-label="project country"
					v-model="searchedFields.countryId"
					:items="countryList"
					item-text="name"
					item-value="id"
					label="Kraj wniosku"
					clearable
				></v-autocomplete>
			</v-flex>
			<v-flex sm1/>
			<v-flex sm3>
				<v-autocomplete
					class="ma-2"
					v-model="searchedFields.projectStatus"
					:items="statusList"
					item-text="statusPL"
					item-value="statusEN"
					label="Status wniosku"
					aria-label="project status"
					clearable
				></v-autocomplete>
			</v-flex>
			<v-flex sm1/>
			<v-flex sm2>
				<v-layout align-center justify-center>
					<v-btn @click="buildNewSearch" color="primary" dark class="ma-2">Szukaj</v-btn>
					<v-btn @click="resetSearch" color="primary" dark class="ma-2">Resetuj</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>

		<v-data-table
			:headers="headers"
			:rows-per-page-items="[10,20,25]"
			:items="projects"
			:pagination.sync="pagination"
			:total-items="itemCount"
			class="elevation-1">
			<template v-slot:items="props">
				<td>{{ props.item.agencyProjectCode }}</td>
				<td>{{ props.item.name }}</td>
				<td>{{ props.item.agencyName }}</td>
				<td>{{ props.item.mainCountry }}</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Api} from "@/api";
	import {AccreditationCountry} from "@/api/generated/AccreditationCountry";
	import {Pagination} from "@/utils/PaginationUtils";
	import {Agency} from "@/api/generated/Agency";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "AgencyProfileProjects",

    mixins: [Filters],

		props: {
			agencyId: {
        required: true
      }
		},

		data () {
			return {
				headers: [
					{text: "Numer wniosku", value: "projectCode", align: "left", sortable: false},
					{text: "Nazwa wniosku", value: "name", align: "left", sortable: false},
					{text: "Nazwa placówki", value: "agencyName", sortable: false},
					{text: "Kraj główny", value: "mainCountry", sortable: false}
				],
				itemCount: 0,
				pagination: {
					rowsPerPage: 25,
					sortBy: null
				},
				projects: [],
				countryList: [],
				agencyList: [],
				dataTable: {
          search: ""
        },

				statusList: [
          { statusPL: 'Wniosek wysłany', statusEN: 'SUBMITTED' },
					{ statusPL: 'Wniosek oczekuje na poprawki', statusEN: 'AWAITING_CORRECTION' },
					{ statusPL: 'Wniosek odrzucony', statusEN: 'REJECTED' },
					{ statusPL: 'Projekt realizowany', statusEN: 'APPROVED' },
					{ statusPL: 'Projekt oczekuje na poprawki', statusEN: 'PROJECT_CHANGES_REQUESTED' },
					{ statusPL: 'Projekt zakończony', statusEN: 'FINISHED' },
					{ statusPL: 'Projekt anulowany', statusEN: 'ANNULLED' },
				],

				searchedFields: Pagination.initSearchedFields([
					'countryId',
					'projectStatus',
					'agencyId',
				]),
			};
		},

		created () {
			this.getCountryList();
			this.getAgencyList();
      this.searchedFields = this.retrieveFilters(this.searchedFields, true);
      this.pagination = this.retrievePagination(this.pagination, true);
		},

		watch: {
			"pagination": {
				handler(pagination) {
					this.buildNewSearch();
          this.paginationRef = pagination;
				},
				deep: true
			},

			"agencyId": {
				immediate: true,
				handler: function (val) {
					this.searchedFields.agencyId = val;
				}
			}
		},

		computed: {
			pages () {
				// paginacja nie została zainicjalizowana
				if (this.pagination.rowsPerPage === undefined) {
					return 0;
				}
				return Math.ceil(this.itemCount / this.pagination.rowsPerPage);
			},
		},

		methods: {
			buildNewSearch () {
				this.dataTable.search = this.buildSearchCriteria();
				this.getItemList();
			},

			getItemList () {
				let sort = this.buildSort();
				Api.get(this,
					"/all-agency-projects/list?search=" + this.dataTable.search
						+ "&page=" + this.pagination.page
						+ "&result=" + this.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.projects = response.itemList;
							this.itemCount = response.itemCount;
						});
			},

			buildSearchCriteria () {
				return Pagination.buildSearchCriteria(this.searchedFields, false);
			},

			buildSort() {
				let order = this.pagination.descending === true ? "desc" : "asc";
				let columnName = this.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			resetSearch () {
				Pagination.resetSearch(this.searchedFields);
        this.searchedFields.agencyId = this.agencyId;
        this.buildNewSearch();
			},

			getCountryList () {
				AccreditationCountry.get(this, successResponse => {
						this.countryList = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować krajów", errorResponse);
					});
			},

			getAgencyList () {
				Agency.getAll(this, successResponse => {
						this.agencyList = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować placówek", errorResponse);
					});
			}
		},
	};
</script>

<style scoped>

</style>
